import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const HOT_KEYWORDS = ["都市情欲", "悬疑禁忌", "古装", "江湖", "经典回顾", "奇幻"];

export default function SearchBanner() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <section className="w-full px-4 md:px-6 pt-10 md:pt-14">
      <div className="rounded-lg border border-background-200/70 bg-gradient-to-r from-primary-950 to-background-100 p-6 md:p-10 text-center">
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
          最新三级影片大全 · 在线观看信息平台
        </h1>
        <p className="mx-auto max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 mb-6">
          覆盖都市、古装、悬疑、江湖与奇幻等热门题材，浏览最新电影资讯与剧情介绍，快速查找感兴趣的三级影片。
        </p>
        <form onSubmit={handleSearch} className="mx-auto flex w-full max-w-2xl flex-col sm:flex-row items-stretch gap-2">
          <div className="relative flex-1">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-500">
              <i className="ri-search-line" />
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="输入影片名称或剧情关键词，如：暗涌"
              className="w-full rounded-full border border-background-300/60 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none focus:border-primary-400 transition-colors"
            />
          </div>
          <button
            type="submit"
            className="shrink-0 rounded-full bg-accent-500 px-8 py-3 text-sm font-medium text-foreground-950 hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            立即搜索
          </button>
        </form>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-foreground-500">热门搜索：</span>
          {HOT_KEYWORDS.map((word) => (
            <button
              key={word}
              type="button"
              onClick={() => navigate(`/search?q=${encodeURIComponent(word)}`)}
              className="rounded-full bg-background-200/70 px-3 py-1 text-xs text-foreground-700 hover:bg-secondary-500 hover:text-foreground-950 transition-colors"
            >
              {word}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}